/*
 * LyteWork Cup Trophy Customizer - v3.0 (Plate Shapes + Headlines)
 * Supports square, horizontal-rectangle, and vertical-rectangle plates
 * Headline tab with Template, Custom Text, and Logo options
 */

class CupTrophyCustomizer {
    constructor() {
        this.config = {
            logoUrl: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Lw_logo_04_Artboard_2_Copy_3.png?v=1732912722',

            plateColors: [
                // Row 1: Silver Engraving
                { id: 'black-silver', name: 'Black / Silver', bgColorKey: 'Black', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_GInv_Black-Silver.png?v=1736619472' },
                { id: 'red-silver', name: 'Red / Silver', bgColorKey: 'Red', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_VN1J_Red-Silver.png?v=1736619486' },
                { id: 'blue-silver', name: 'Blue / Silver', bgColorKey: 'Blue', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_GhYz_Blue-Silver.png?v=1736619495' },
                { id: 'green-silver', name: 'Green / Silver', bgColorKey: 'Green', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_CXht_Green-Silver.png?v=1736619505' },
                
                // Row 2: Gold Engraving
                { id: 'black-gold', name: 'Black / Gold', bgColorKey: 'Black', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_USN2_Black-Gold.png?v=1736619513' },
                { id: 'red-gold', name: 'Red / Gold', bgColorKey: 'Red', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_ZG4L_Red-Gold.png?v=1736619522' },
                { id: 'blue-gold', name: 'Blue / Gold', bgColorKey: 'Blue', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_rxOr_Blue-Gold.png?v=1736619531' },
                { id: 'green-gold', name: 'Green / Gold', bgColorKey: 'Green', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_lhKa_Green-Gold.png?v=1736619540' }
            ],
            acrylicPlate: {
                id: 'acrylic',
                name: 'Acrylic Plate',
                bgColor: '#d9d9d9',
                engravingColor: '#f7f7f7',
                cost: 0
            },
            backgroundPlates: {
                Black: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_0sYk_Black_20Metal.png?v=1736619548',
                Red: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_pQJS_Red_20Metal.png?v=1736619603',
                Blue: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_CC7H_Blue_20Metal.png?v=1736619615',
                Green: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_6Fms_Green_20Metal.png?v=1736619624'
            },
            basePlates: {
                Gold: { url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_7osf_Gold_20Metal.png?v=1736619642', cost: 0.99 },
                Silver: { url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_EbR7_Silver_20Metal.png?v=1736619633', cost: 0.99 }
            },

            // Plate shape configurations (detected via product tags)
            plateShapes: {
                square:     { ratio: '4 / 3.5', label: 'Square' },
                horizontal: { ratio: '3 / 2',   label: 'Horizontal' },
                vertical:   { ratio: '2 / 3',   label: 'Vertical' }
            },

            // Headline Templates (shared with plaque customizer)
            headlineTemplates: {
                'Corporate Awards': [
                    { name: 'Employee of the Year', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/EMPLOYEE_OF_THE_YEAR.png?v=1751592307' },
                    { name: 'Employee of the Month', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/EMPLOYEE_OF_THE_MONTH.png?v=1751592306'},
                    { name: 'Leadership Award 1', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/LEADERSHIP_1.png?v=1751592307' },
                    { name: 'Leadership Award 2', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/LEADERSHIP_2.png?v=1751592306' },
                    { name: 'World Class Leadership', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WORLD_CLASS_LEADERSHIP.png?v=1751592306' },
                    { name: 'Years of Service 1', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/YEARS_OF_SERVICE_1.png?v=1751592306' },
                    { name: 'Years of Service 2', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/YEARS_OF_SERVICE_2.png?v=1751592306' },
                    { name: 'Years of Service 3', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/YEARS_OF_SERVICE_3.png?v=1751592305' },
                    { name: 'Retirement', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/RETIREMENT.png?v=1751592306' }
                ],
                'School Awards': [
                    { name: 'Attendance', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ATTENDANCE.png?v=1751592306' },
                    { name: 'Citizenship', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/CITIZENSHIP_AWARD.png?v=1751592306' },
                    { name: 'Academic Excellence', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ACADEMIC_EXCELLENCE.png?v=1751592306' }
                ],
                'Placement': [
                    { name: '1st Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/1ST_PLACE_2.png?v=1753494295' },
                    { name: '2nd Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/2ND_PLACE_2.png?v=1753494316' },
                    { name: '3rd Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/3RD_PLACE_2.png?v=1753494329' },
                    { name: '4th Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/4TH_PLACE_2.png?v=1753494337' },
                    { name: '5th Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/5TH_PLACE_2.png?v=1753494346' },
                    { name: '6th Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/6TH_PLACE_2.png?v=1753494353' },
                    { name: 'Honorable Mention', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/HONORABLE_MENTION.png?v=1751592306' },
                    { name: 'Participant', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/PARTICIPANT.png?v=1751592306' }
                ],
                'Recognition': [
                    { name: 'All Star Award', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ALL_STAR_AWARD.png?v=1751592306' },
                    { name: 'Super Star Award', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/SUPER_STAR_AWARD.png?v=1751592306' },
                    { name: 'Rising Star Award', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/RISING_STAR_AWARD.png?v=1751592306' },
                    { name: 'Award of Excellence', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/AWARD_OF_EXCELLENCE.png?v=1751592306' },
                    { name: 'Special Recognition', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/SPECIAL_RECOGNITION.png?v=1751592306' },
                    { name: 'In Appreciation', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/In_Appreciation.png?v=1751592306' },
                    { name: 'With Heartfelt Appreciation', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WITH_HEARTFELT_APPRECIATION.png?v=1751592306' }
                ],
                'Coach Awards': [
                    { name: 'Baseball Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-BASEBALL.png?v=1751592306' },
                    { name: 'Basketball Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-BASKETBALL.png?v=1751592306' },
                    { name: 'Bowling Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-BOWLING.png?v=1751592306' },
                    { name: 'Hockey Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-HOCKEY.png?v=1751592306' },
                    { name: 'Football Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-FOOTBALL.png?v=1751592306' },
                    { name: 'Volleyball Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-VOLLEYBALL.png?v=1751592306' },
                    { name: 'Soccer Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-SOCCER.png?v=1751592306' },
                    { name: 'Tennis Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-TENNIS.png?v=1751592306' }
                ]
            },

            fonts: [
                { name: 'Arial', value: 'Arial, sans-serif' },
                { name: 'Times New Roman', value: "'Times New Roman', serif" },
                { name: 'Georgia', value: 'Georgia, serif' },
                { name: 'Copperplate', value: "'Copperplate', fantasy", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COPRGTB.TTF?v=1751605768' },
                { name: 'Monotype Corsiva', value: "'Monotype Corsiva', cursive", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/MTCORSVA.TTF?v=1751605992' },
                { name: 'Engravers', value: "'Engravers MT', serif", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ENGR.TTF?v=1751606144' }
            ],

            fees: {
                logoSetup: 15.00
            }
        };

        this.state = {
            product: {
                isAcrylic: false,
                plateShape: 'square', // 'square' | 'horizontal' | 'vertical'
                variantId: null,
                basePrice: 0
            },
            style: {
                plateColor: null, 
                useBasePlate: false
            },
            headline: {
                type: 'None',        // 'None' | 'Template' | 'Custom' | 'Logo'
                template: null,
                customText: '',
                customFont: "'Copperplate', fantasy",
                customSize: 28,
                uploadedLogo: null,
                logoSize: 70,
                logoSetupFee: false
            },
            text: {
                line1: { id: 'line1', content: 'Line 1 Text', font: "'Times New Roman', serif", size: 50, isBold: false, isItalic: false, isActive: true },
                line2: { id: 'line2', content: 'Line 2 Text', font: "'Times New Roman', serif", size: 50, isBold: false, isItalic: false, isActive: true },
                line3: { id: 'line3', content: '', font: "'Times New Roman', serif", size: 32, isBold: false, isItalic: false, isActive: true },
                line4: { id: 'line4', content: '', font: "'Times New Roman', serif", size: 32, isBold: false, isItalic: false, isActive: true }
            },
            quantity: 1,
            trophyPlates: [], 
            copyPlateSettings: {
                line1: false, line2: false, line3: false, line4: false
            }
        };

        this.modal = null;
        
        // Bind trigger handler once for proper add/remove event listener handling
        this.boundTriggerHandler = this.handleTriggerClick.bind(this);
        
        this.init();
    }
    
    init() {
        this.loadFonts();
        this.attachTrigger();
    }
    
    loadFonts() {
        if (document.getElementById('lw-customizer-fonts')) return;
        const style = document.createElement('style');
        style.id = 'lw-customizer-fonts';
        style.textContent = this.config.fonts
            .filter(f => f.url)
            .map(f => `@font-face { font-family: '${f.name}'; src: url('${f.url}'); }`)
            .join('\n');
        document.head.appendChild(style);
    }
    
    // Uses Event Delegation on the document
    attachTrigger() {
        document.removeEventListener('click', this.boundTriggerHandler);
        document.addEventListener('click', this.boundTriggerHandler);
        console.log('[OK] Cup Trophy Customizer: Global trigger attached.');
    }

    handleTriggerClick(e) {
        const trigger = e.target.closest('.lw-cuptrophy-trigger');
        if (trigger) {
            e.preventDefault();
            e.stopPropagation();
            this.open();
        }
    }
    
    async open() {
        if (document.querySelector('.lw-cuptrophy-modal')) return;

        await this.fetchProductData();
        this.buildModal();
        this.attachEventListeners();
        this.setupVariantChangeListener();
        this.updatePreview();
        this.updatePrice();
        this.lockBodyScroll();
        requestAnimationFrame(() => this.modal.classList.add('active'));
    }

    lockBodyScroll() {
        this.scrollY = window.scrollY;
        document.body.classList.add('lw-modal-open');
        document.documentElement.classList.add('lw-modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
    }
    
    close() {
        if (this.modal) {
            document.body.classList.remove('lw-modal-open');
            document.documentElement.classList.remove('lw-modal-open');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.overflow = '';
            if (this.scrollY !== undefined) {
                window.scrollTo(0, this.scrollY);
            }
            this.modal.remove();
            this.modal = null;
        }
    }

    async fetchProductData(passedVariant = null) {
        try {
            const productHandleMatch = window.location.pathname.match(/\/products\/([a-z0-9-]+)/);
            if (!productHandleMatch) throw new Error("Could not find product handle in URL.");
            
            const response = await fetch(`/products/${productHandleMatch[1]}.js`);
            if (!response.ok) throw new Error(`Failed to fetch product JSON: ${response.statusText}`);
            
            const product = await response.json();
            
            let variant;
            if (passedVariant) {
                variant = passedVariant;
            } else {
                let currentVariantId = new URL(window.location).searchParams.get('variant');
                if (!currentVariantId) {
                    const formInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
                    if (formInput) currentVariantId = formInput.value;
                }
                variant = product.variants.find(v => v.id == currentVariantId) || product.variants[0];
            }
            
            this.state.product.isAcrylic = product.tags.includes('acrylic-cup-plate');

            // Detect plate shape from product tags
            if (product.tags.includes('vertical-rectangle-plate')) {
                this.state.product.plateShape = 'vertical';
            } else if (product.tags.includes('horizontal-rectangle-plate')) {
                this.state.product.plateShape = 'horizontal';
            } else {
                this.state.product.plateShape = 'square';
            }
            
            this.state.product = {
                ...this.state.product,
                title: product.title,
                variantId: variant.id,
                variantTitle: variant.title,
                basePrice: variant.price / 100,
                featuredImage: variant.featured_image?.src || product.featured_image,
            };

            if (this.state.product.isAcrylic) {
                this.state.style.plateColor = this.config.acrylicPlate;
                this.state.style.useBasePlate = false; 
            } else {
                if (!this.state.style.plateColor || this.state.style.plateColor.id === 'acrylic') {
                     this.state.style.plateColor = this.config.plateColors[0];
                }
            }
            
        } catch (error) {
            console.error('Error fetching product:', error);
            this.state.product = {
                ...this.state.product,
                title: 'Cup Trophy',
                basePrice: 10,
                featuredImage: '',
                isAcrylic: false,
                variantId: null
            };
            this.state.style.plateColor = this.config.plateColors[0];
        }
    }

    setupVariantChangeListener() {
        if (this._variantListener) document.removeEventListener('variant:change', this._variantListener);
        
        this._variantListener = async (e) => {
            const newVariant = e.detail.variant || e.variant;
            if (this.modal) {
                if (newVariant) await this.fetchProductData(newVariant); 
                else await this.fetchProductData();
                
                this.updatePrice();
                this.updatePreview();
                
                const activeTab = this.modal.querySelector('.lw-cuptrophy-tab.active');
                if (activeTab) this.switchTab(activeTab.dataset.tab);
            }
        };
        document.addEventListener('variant:change', this._variantListener);
    }

    // Get the CSS aspect-ratio value for the current plate shape
    getPlateAspectRatio() {
        const shape = this.config.plateShapes[this.state.product.plateShape];
        return shape ? shape.ratio : this.config.plateShapes.square.ratio;
    }

    buildModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'lw-cuptrophy-modal'; 
        this.modal.innerHTML = `
            <div class="lw-cuptrophy-overlay"></div>
            <div class="lw-cuptrophy-container">
                <header class="lw-cuptrophy-header">
                    <div class="lw-header-left">
                        <img src="${this.config.logoUrl}" alt="Logo" class="lw-header-logo">
                        <div>
                            <h2>${this.state.product.title}</h2>
                            <p>${this.state.product.variantTitle === 'Default Title' ? '' : (this.state.product.variantTitle || '')}</p>
                        </div>
                    </div>
                    <button class="lw-cuptrophy-close">&times;</button>
                </header>
                
                <div class="lw-cuptrophy-body">
                    <div class="lw-cuptrophy-preview-section">
                        <div class="lw-cuptrophy-preview-container" data-plate-shape="${this.state.product.plateShape}" style="aspect-ratio: ${this.getPlateAspectRatio()};">
                            <div class="lw-cuptrophy-baseplate"></div>
                            <div class="lw-cuptrophy-plate">
                                <div class="lw-cuptrophy-engraving">
                                    <div class="lw-headline-layer"></div>
                                    <div class="lw-text-layer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="lw-cuptrophy-options-section">
                        <div class="lw-cuptrophy-tabs">
                            <button class="lw-cuptrophy-tab active" data-tab="plate-options">Plate Options</button>
                            <button class="lw-cuptrophy-tab" data-tab="headline">Headline</button>
                            <button class="lw-cuptrophy-tab" data-tab="text">Text</button>
                            <button class="lw-cuptrophy-tab" data-tab="quantity">Multiples</button>
                        </div>
                        
                        <div class="lw-cuptrophy-tab-content">
                            ${this.renderPlateOptionsTab()}
                        </div>
                    </div>
                </div>
                
                <footer class="lw-cuptrophy-footer">
                    <div class="lw-footer-quantity">
                        <span>Qty:</span>
                        <div class="lw-quantity-control lw-footer-qty-control">
                            <button class="lw-qty-btn lw-footer-qty-btn" data-action="decrease">−</button>
                            <input type="number" class="lw-qty-input lw-footer-qty-input" value="${this.state.quantity}" min="1" max="100">
                            <button class="lw-qty-btn lw-footer-qty-btn" data-action="increase">+</button>
                        </div>
                    </div>
                    <div class="lw-cuptrophy-price">
                        <div class="lw-price-line-footer per-item">
                            <span>Per Item:</span>
                            <span class="lw-cuptrophy-price-per-item">$0.00</span>
                        </div>
                        <div class="lw-price-line-footer total">
                            <span>Total:</span>
                            <span class="lw-cuptrophy-price-value">$0.00</span>
                        </div>
                    </div>
                    <button type="button" class="lw-cuptrophy-btn lw-cuptrophy-btn-primary" id="addToCartBtn">Add to Cart</button>
                </footer>

                <div id="lw-processing-overlay" class="lw-processing-overlay" style="display:none;">
                    <div class="lw-processing-content">
                        <div class="lw-spinner"></div>
                        <p>Processing your design...</p>
                    </div>
                </div>
            </div>

            <div id="lw-loading" class="lw-loading" style="display:none;">
                <div class="lw-loading-content">
                    <svg class="animated-logo-svg" viewBox="0 0 184.09 129.97">
                        <path id="logo-path-animation" fill="none" stroke="#d6c390" stroke-width="3" 
                        d="M130.28,0l-19.11,19.11L92.05,0l-19.11,19.11L53.82,0l-23.16,23.16,41.09,41.09h40.6l17.93-17.93,4.05-4.05,19.11-19.11L130.28,0ZM92.05,8.1l15.06,15.06-15.06,15.06-15.06-15.06,15.06-15.06ZM109.98,58.53h-35.86L38.75,23.16l15.06-15.06,15.06,15.06,23.16,23.16,19.11-19.11,15.06,15.06-16.25,16.25ZM130.28,38.23l-15.06-15.06,15.06-15.06,15.06,15.06-15.06,15.06Z"/>
                    </svg>
                    <p class="lw-loading-text">Processing your Perfection...</p>
                </div>
            </div>
        `;
        document.body.appendChild(this.modal);
    }

    // =============================================
    // TAB RENDERERS
    // =============================================

    renderPlateOptionsTab() {
        const isAcrylic = this.state.product.isAcrylic;
        return `
            <div class="lw-cuptrophy-tab-pane active" data-pane="plate-options">
                <h4>Plate Color</h4>
                ${isAcrylic ? '<p class="lw-help-text">Color options are disabled for acrylic plates.</p>' : ''}
                <div class="lw-color-grid">
                    ${this.config.plateColors.map(plate => {
                        const costText = plate.cost > 0 ? ` (+$${plate.cost.toFixed(2)})` : '';
                        return `
                        <div class="lw-color-option ${this.state.style.plateColor.id === plate.id ? 'active' : ''} ${isAcrylic ? 'disabled' : ''}" 
                             data-plate-id="${plate.id}">
                            <img src="${plate.img}" alt="${plate.name}" class="lw-color-thumb">
                            <span>${plate.name}${costText}</span>
                        </div>
                    `}).join('')}
                    ${isAcrylic ? `<div class="lw-color-option active disabled" data-plate-id="acrylic"><span>${this.config.acrylicPlate.name}</span></div>` : ''}
                </div>
                <h4>Options</h4>
                ${this.renderBasePlateToggle(isAcrylic)}
            </div>
        `;
    }

    renderBasePlateToggle(isDisabled = false) {
        return `
        <label class="lw-toggle-option ${isDisabled ? 'disabled' : ''}">
            <span class="lw-toggle">
                <input type="checkbox" id="basePlateToggle" ${this.state.style.useBasePlate ? 'checked' : ''} ${isDisabled ? 'disabled' : ''}>
                <span class="lw-toggle-slider"></span>
            </span>
            <span>Add Base Plate (+$${this.config.basePlates.Gold.cost.toFixed(2)})${isDisabled ? ' - N/A for Acrylic' : ''}</span>
        </label>
        `;
    }

    // =============================================
    // HEADLINE TAB
    // =============================================

    renderHeadlineTab() {
        return `
            <div class="lw-cuptrophy-tab-pane" data-pane="headline">
                <h4>Headline Type</h4>
                <div class="lw-headline-types">
                    <label class="lw-radio-option ${this.state.headline.type === 'None' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="None" ${this.state.headline.type === 'None' ? 'checked' : ''}>
                        <span>No Headline</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Template' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Template" ${this.state.headline.type === 'Template' ? 'checked' : ''}>
                        <span>Choose Design</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Custom' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Custom" ${this.state.headline.type === 'Custom' ? 'checked' : ''}>
                        <span>Custom Text</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Logo' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Logo" ${this.state.headline.type === 'Logo' ? 'checked' : ''}>
                        <span>Upload Logo</span>
                    </label>
                </div>
                
                <div id="headlineContent"></div>
            </div>
        `;
    }

    renderHeadlineContent() {
        const container = this.modal.querySelector('#headlineContent');
        if (!container) return;
        
        switch (this.state.headline.type) {
            case 'Template':
                container.innerHTML = this.renderTemplateSelector();
                setTimeout(() => this.attachTemplateEvents(), 10);
                break;
            case 'Custom':
                container.innerHTML = this.renderCustomHeadline();
                setTimeout(() => this.attachCustomHeadlineEvents(), 10);
                break;
            case 'Logo':
                container.innerHTML = this.renderLogoUpload();
                setTimeout(() => this.attachLogoEvents(), 10);
                break;
            default:
                container.innerHTML = '';
        }
    }

    renderTemplateSelector() {
        const categories = Object.keys(this.config.headlineTemplates);
        const activeCategory = categories[0];
        
        return `
            <div class="lw-template-selector">
                <div class="lw-template-categories">
                    ${categories.map((cat, i) => `
                        <button class="lw-template-cat-btn ${i === 0 ? 'active' : ''}" data-category="${cat}">
                            ${cat}
                        </button>
                    `).join('')}
                </div>
                <div class="lw-template-grid">
                    ${this.config.headlineTemplates[activeCategory].map(template => `
                        <div class="lw-template-option ${this.state.headline.template?.url === template.url ? 'active' : ''}"
                             data-url="${template.url}" data-name="${template.name}">
                            <img src="${template.url}" alt="${template.name}">
                            <span>${template.name}</span>
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
    }

    renderCustomHeadline() {
        return `
            <div class="lw-custom-headline-controls">
                <label>Headline Text</label>
                <input type="text" class="lw-text-input" id="customHeadlineText" 
                       value="${this.state.headline.customText}" 
                       placeholder="e.g., Employee of the Month">
                
                <div class="lw-field-controls" style="margin-top: 12px;">
                    <select class="lw-font-select" id="customHeadlineFont">
                        ${this.config.fonts.map(font => 
                            `<option value="${font.value}" ${this.state.headline.customFont === font.value ? 'selected' : ''}>${font.name}</option>`
                        ).join('')}
                    </select>
                    <div class="lw-size-control">
                        <button class="lw-size-btn" id="headlineSizeDown">−</button>
                        <span id="headlineSize">${this.state.headline.customSize}px</span>
                        <button class="lw-size-btn" id="headlineSizeUp">+</button>
                    </div>
                </div>
            </div>
        `;
    }

    renderLogoUpload() {
        return `
            <div class="lw-logo-upload">
                <!-- Logo setup fee disabled for now
                <p class="lw-warning">⚠️ Logo setup fee: $${this.config.fees.logoSetup.toFixed(2)} (one-time)</p>
                -->
                <div class="lw-upload-area ${this.state.headline.uploadedLogo ? 'has-file' : ''}" id="logoUploadArea">
                    ${this.state.headline.uploadedLogo ? 
                        `<img src="${this.state.headline.uploadedLogo}" alt="Logo" style="max-width: ${this.state.headline.logoSize || 70}%; max-height: ${this.state.headline.logoSize || 70}%;">` :
                        `<div class="lw-upload-prompt">
                            <span>📁</span>
                            <span>Click to upload logo</span>
                        </div>`
                    }
                </div>
                <input type="file" id="logoFileInput" accept="image/*" style="display: none;">
                
                ${this.state.headline.uploadedLogo ? `
                    <div class="lw-logo-controls">
                        <label>Logo Size</label>
                        <div class="lw-logo-size-slider">
                            <input type="range" id="logoSizeSlider" min="30" max="90" value="${this.state.headline.logoSize || 70}" step="5">
                            <span id="logoSizeValue">${this.state.headline.logoSize || 70}%</span>
                        </div>
                    </div>
                    
                    <!-- Logo setup fee disabled for now
                    <label class="lw-checkbox-option">
                        <input type="checkbox" id="logoSetupFee" ${this.state.headline.logoSetupFee ? 'checked' : ''}>
                        <span>Add logo setup fee (+$${this.config.fees.logoSetup.toFixed(2)})</span>
                    </label>
                    <p class="lw-help-text">Skip if you've already paid for this logo</p>
                    -->
                ` : ''}
            </div>
        `;
    }

    // =============================================
    // TEXT TAB (unchanged logic)
    // =============================================

    renderTextTab() {
        return `
            <div class="lw-cuptrophy-tab-pane" data-pane="text">
                <h4>Engraving Text</h4>
                <p class="lw-help-text">Add up to 4 lines of text. Text will be centered on the plate.</p>
                
                ${this.renderTextLineField(this.state.text.line1, 'Line 1')}
                
                ${this.renderToggleableLine('line2', 'Line 2')}
                ${this.renderToggleableLine('line3', 'Line 3')}
                ${this.renderToggleableLine('line4', 'Line 4')}
            </div>
        `;
    }

    renderToggleableLine(lineId, label) {
        if (this.state.text[lineId].isActive) {
            return `
                ${this.renderTextLineField(this.state.text[lineId], label)}
                <div style="text-align: right; margin-bottom: 15px;">
                    <button class="lw-text-action-btn remove" data-toggle-line="${lineId}" data-action="remove">Remove ${label}</button>
                </div>
            `;
        } else {
            return `
                <div class="lw-add-line-wrapper">
                     <button class="lw-text-action-btn add" data-toggle-line="${lineId}" data-action="add">+ Add ${label}</button>
                </div>
            `;
        }
    }

    renderTextLineField(line, label) {
        return `
            <div class="lw-text-field" data-line-id="${line.id}">
                <div class="lw-field-header">
                    <label>${label}</label>
                    <div class="lw-field-controls">
                        <select class="lw-font-select" data-field="${line.id}">
                            ${this.config.fonts.map(font => 
                                `<option value="${font.value}" ${line.font === font.value ? 'selected' : ''}>${font.name}</option>`
                            ).join('')}
                        </select>
                        <div class="lw-size-control">
                            <button class="lw-size-btn" data-field="${line.id}" data-delta="-2">-</button>
                            <span>${line.size}px</span>
                            <button class="lw-size-btn" data-field="${line.id}" data-delta="2">+</button>
                        </div>
                        <div class="lw-style-controls">
                            <button class="lw-style-btn ${line.isBold ? 'active' : ''}" data-field="${line.id}" data-style="isBold"><b>B</b></button>
                            <button class="lw-style-btn ${line.isItalic ? 'active' : ''}" data-field="${line.id}" data-style="isItalic"><i>I</i></button>
                        </div>
                    </div>
                </div>
                <input type="text" class="lw-text-input" data-field="${line.id}" value="${line.content}">
            </div>
        `;
    }

    // =============================================
    // QUANTITY TAB (unchanged logic)
    // =============================================
    
    renderQuantityTab() {
        this.syncPlatesArray();
        return `
        <div class="lw-cuptrophy-tab-pane" data-pane="quantity">
            <h4>Multiple Plates</h4>
            <p class="lw-help-text">Use the quantity control in the footer to set how many plates you need. ${this.state.quantity > 1 ? 'Customize each plate\'s text below.' : 'Increase quantity to customize individual plates.'}</p>

            ${this.state.quantity > 1 ? `
                <div class="lw-plates-section">
                    <h4>Engraving Details</h4>
                    <div class="lw-copy-settings">
                        <h5>Copy to All Plates:</h5>
                        <div class="lw-copy-options-grid">
                            ${['line1', 'line2', 'line3', 'line4'].map(l => 
                                this.state.text[l].isActive ? `
                                <label class="lw-copy-checkbox">
                                    <input type="checkbox" data-copy-field="${l}" ${this.state.copyPlateSettings[l] ? 'checked' : ''}>
                                    <span>${l.replace('line', 'Line ')}</span>
                                </label>` : ''
                            ).join('')}
                        </div>
                    </div>
                    <div class="lw-plates-table-wrapper">
                        <table class="lw-plates-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    ${['line1', 'line2', 'line3', 'line4'].map(l => 
                                        this.state.text[l].isActive ? `<th>${l.replace('line', 'Line ')}</th>` : ''
                                    ).join('')}
                                </tr>
                            </thead>
                            <tbody>${this.renderPlatesTableRows()}</tbody>
                        </table>
                    </div>
                </div>
            ` : ''}
            <div class="lw-price-breakdown">${this.renderPriceBreakdown()}</div>
        </div>
        `;
    }
    
    syncPlatesArray() {
        const defaults = {
            line1: this.state.text.line1.content,
            line2: this.state.text.line2.content,
            line3: this.state.text.line3.content,
            line4: this.state.text.line4.content
        };

        if (this.state.trophyPlates.length > this.state.quantity) {
            this.state.trophyPlates = this.state.trophyPlates.slice(0, this.state.quantity);
        } else {
            while (this.state.trophyPlates.length < this.state.quantity) {
                if (this.state.trophyPlates.length === 0) {
                    this.state.trophyPlates.push({...defaults});
                } else {
                    this.state.trophyPlates.push({
                        line1: this.state.copyPlateSettings.line1 ? this.state.trophyPlates[0].line1 : defaults.line1,
                        line2: this.state.copyPlateSettings.line2 ? this.state.trophyPlates[0].line2 : defaults.line2,
                        line3: this.state.copyPlateSettings.line3 ? this.state.trophyPlates[0].line3 : defaults.line3,
                        line4: this.state.copyPlateSettings.line4 ? this.state.trophyPlates[0].line4 : defaults.line4
                    });
                }
            }
        }
    }

    renderPlatesTableRows() {
        return this.state.trophyPlates.map((plate, index) => {
            const isCopied = (field) => index > 0 && this.state.copyPlateSettings[field];
            let cols = '';
            ['line1', 'line2', 'line3', 'line4'].forEach(line => {
                if (this.state.text[line].isActive) {
                    cols += `<td>
                        <input type="text" class="lw-table-input" 
                               data-plate-index="${index}" data-field="${line}"
                               value="${plate[line]}" ${isCopied(line) ? 'readonly' : ''}>
                    </td>`;
                }
            });
            return `<tr data-row-index="${index}"><td class="row-number">${index + 1}</td>${cols}</tr>`;
        }).join('');
    }

    // =============================================
    // EVENT LISTENERS
    // =============================================

    attachEventListeners() {
        this.modal.querySelector('.lw-cuptrophy-close').addEventListener('click', () => this.close());
        this.modal.querySelector('.lw-cuptrophy-overlay').addEventListener('click', () => this.close());
        this.modal.querySelectorAll('.lw-cuptrophy-tab').forEach(tab => {
            tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
        });
        this.attachPlateOptionsEvents();
        this.modal.querySelector('#addToCartBtn').addEventListener('click', (e) => {
            e.preventDefault();
            this.addToCart();
        });

        // Footer quantity buttons (always visible)
        this.modal.querySelectorAll('.lw-footer-qty-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.dataset.action === 'increase') {
                    this.updateQuantity(1);
                } else {
                    this.updateQuantity(-1);
                }
            });
        });

        // Footer quantity input
        const footerQtyInput = this.modal.querySelector('.lw-footer-qty-input');
        if (footerQtyInput) {
            footerQtyInput.addEventListener('change', (e) => {
                this.updateQuantity(0, parseInt(e.target.value));
            });
            footerQtyInput.addEventListener('input', (e) => {
                const val = parseInt(e.target.value);
                if (val && val > 0) {
                    this.updateQuantity(0, val);
                }
            });
        }

        // Watch page quantity break radios and page qty input (once only)
        if (!this._radioListenersAttached) {
            this.setupRadioListeners();
            this._radioListenersAttached = true;
        }

        // Sync initial quantity from page
        this.syncQuantity();
    }

    attachPlateOptionsEvents() {
        this.modal.querySelectorAll('[data-plate-id]').forEach(el => {
            el.addEventListener('click', () => {
                if (this.state.product.isAcrylic) return; 
                const plateId = el.dataset.plateId;
                this.state.style.plateColor = this.config.plateColors.find(c => c.id === plateId);
                this.modal.querySelectorAll('[data-plate-id]').forEach(e => e.classList.remove('active'));
                el.classList.add('active');
                this.updatePreview();
                this.updatePrice();
            });
        });
        const basePlateToggle = this.modal.querySelector('#basePlateToggle');
        if (basePlateToggle) {
            basePlateToggle.addEventListener('change', (e) => {
                this.state.style.useBasePlate = e.target.checked;
                this.updatePreview();
                this.updatePrice();
            });
        }
    }

    // --- Page Quantity Sync & Qty Break Listeners ---

    setupRadioListeners() {
        // Use EVENT DELEGATION on document for all page-level elements.
        // The Ecomify theme may re-render the quantity area when radios change,
        // which destroys directly-bound listeners. Delegation survives re-renders.
        // IMPORTANT: All handlers guard with this.modal check so they only run
        // when the customizer modal is open — otherwise they'd break qty on every page.

        document.addEventListener('change', (e) => {
            if (!this.modal) return; // Only active when modal is open

            // Qty break radio buttons
            if (e.target.matches('input[name="product-qty-breaks"]')) {
                const qty = parseInt(e.target.dataset.qty);
                if (qty) this.updateQuantity(0, qty);
            }
            // Page quantity input
            if (e.target.matches('input[name="quantity"]')) {
                const qty = parseInt(e.target.value) || 1;
                this.updateQuantity(0, qty);
            }
        });

        document.addEventListener('input', (e) => {
            if (!this.modal) return; // Only active when modal is open

            if (e.target.matches('input[name="quantity"]')) {
                const qty = parseInt(e.target.value) || 1;
                this.updateQuantity(0, qty);
            }
        });

        // Page +/- buttons — delegation to catch re-rendered buttons
        document.addEventListener('click', (e) => {
            if (!this.modal) return; // Only active when modal is open

            const btn = e.target.closest('[data-quantity-plus], [data-quantity-minus], .quantity-plus, .quantity-minus, .qty-btn, button[name="plus"], button[name="minus"]');
            if (btn) {
                setTimeout(() => {
                    const pageQty = document.querySelector('input[name="quantity"]');
                    if (pageQty) {
                        const qty = parseInt(pageQty.value) || 1;
                        this.updateQuantity(0, qty);
                    }
                }, 100); // Slightly longer delay for theme to finish updating
            }
        });
    }

    syncQuantity() {
        const q = document.querySelector('input[name="quantity"]');
        if (q) this.updateQuantity(0, parseInt(q.value) || 1);
    }

    updateQuantity(change, setVal) {
        // Prevent infinite loops from event listeners
        if (this._updatingQuantity) return;
        this._updatingQuantity = true;

        try {
            let newQty = (setVal !== undefined) ? setVal : this.state.quantity + change;
            this.state.quantity = Math.max(1, newQty);

            // Update footer qty input
            const footerInput = this.modal.querySelector('.lw-footer-qty-input');
            if (footerInput) footerInput.value = this.state.quantity;

            // Sync to main page quantity input AND dispatch events so the theme updates
            const mainInput = document.querySelector('input[name="quantity"]');
            if (mainInput && parseInt(mainInput.value) !== this.state.quantity) {
                mainInput.value = this.state.quantity;
                mainInput.dispatchEvent(new Event('change', { bubbles: true }));
                mainInput.dispatchEvent(new Event('input', { bubbles: true }));
            }

            // Auto-check the correct qty-break radio to match current quantity
            this.syncQtyBreakRadio();

            // Re-render quantity tab if it's active (for bulk editing table)
            const activeTab = this.modal.querySelector('.lw-cuptrophy-tab.active');
            if (activeTab && activeTab.dataset.tab === 'quantity') {
                this.switchTab('quantity');
            }

            this.updatePrice();
        } finally {
            this._updatingQuantity = false;
        }
    }

    // Auto-check the best matching qty-break radio for current quantity
    syncQtyBreakRadio() {
        const radios = document.querySelectorAll('input[name="product-qty-breaks"]');
        if (radios.length === 0) return;

        let bestTier = null;
        radios.forEach(r => {
            const qty = parseInt(r.dataset.qty);
            if (qty <= this.state.quantity && (!bestTier || qty > bestTier.qty)) {
                bestTier = { qty: qty, el: r };
            }
        });

        if (bestTier) {
            if (!bestTier.el.checked) {
                bestTier.el.checked = true;
            }
        } else {
            // No tier matches current qty - uncheck all
            radios.forEach(r => r.checked = false);
        }
    }

    // --- Headline Events ---

    attachHeadlineEvents() {
        setTimeout(() => {
            const radioButtons = this.modal.querySelectorAll('input[name="headlineType"]');
            
            radioButtons.forEach(radio => {
                radio.addEventListener('change', (e) => {
                    this.state.headline.type = e.target.value;
                    
                    this.modal.querySelectorAll('.lw-radio-option').forEach(opt => {
                        opt.classList.remove('active');
                    });
                    e.target.closest('.lw-radio-option').classList.add('active');
                    
                    this.renderHeadlineContent();

                    setTimeout(() => {
                        const contentArea = this.modal.querySelector('#headlineContent');
                        if (contentArea) {
                            contentArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }, 100);

                    this.updatePreview();
                    this.updatePrice();
                });
            });
            
            if (this.state.headline.type !== 'None') {
                this.renderHeadlineContent();
            }
        }, 50);
    }

    attachTemplateEvents() {
        this.modal.querySelectorAll('.lw-template-cat-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const category = btn.dataset.category;
                
                this.modal.querySelectorAll('.lw-template-cat-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                const grid = this.modal.querySelector('.lw-template-grid');
                grid.innerHTML = this.config.headlineTemplates[category].map(template => `
                    <div class="lw-template-option ${this.state.headline.template?.url === template.url ? 'active' : ''}"
                         data-url="${template.url}" data-name="${template.name}">
                        <img src="${template.url}" alt="${template.name}">
                        <span>${template.name}</span>
                    </div>
                `).join('');
                
                this.attachTemplateSelectionEvents();
            });
        });
        
        this.attachTemplateSelectionEvents();
    }

    attachTemplateSelectionEvents() {
        this.modal.querySelectorAll('.lw-template-option').forEach(el => {
            el.addEventListener('click', () => {
                this.state.headline.template = {
                    url: el.dataset.url,
                    name: el.dataset.name
                };
                
                this.modal.querySelectorAll('.lw-template-option').forEach(e => e.classList.remove('active'));
                el.classList.add('active');
                
                this.updatePreview();
            });
        });
    }

    attachCustomHeadlineEvents() {
        const textInput = this.modal.querySelector('#customHeadlineText');
        const fontSelect = this.modal.querySelector('#customHeadlineFont');
        const sizeDown = this.modal.querySelector('#headlineSizeDown');
        const sizeUp = this.modal.querySelector('#headlineSizeUp');
        
        if (textInput) {
            textInput.addEventListener('input', (e) => {
                this.state.headline.customText = e.target.value;
                this.updatePreview();
            });
        }
        
        if (fontSelect) {
            fontSelect.addEventListener('change', (e) => {
                this.state.headline.customFont = e.target.value;
                this.updatePreview();
            });
        }
        
        if (sizeDown) {
            ['click', 'touchstart'].forEach(evt => {
                sizeDown.addEventListener(evt, (e) => {
                    e.preventDefault();
                    this.state.headline.customSize = Math.max(16, this.state.headline.customSize - 2);
                    this.modal.querySelector('#headlineSize').textContent = `${this.state.headline.customSize}px`;
                    this.updatePreview();
                });
            });
        }
        
        if (sizeUp) {
            ['click', 'touchstart'].forEach(evt => {
                sizeUp.addEventListener(evt, (e) => {
                    e.preventDefault();
                    this.state.headline.customSize = Math.min(48, this.state.headline.customSize + 2);
                    this.modal.querySelector('#headlineSize').textContent = `${this.state.headline.customSize}px`;
                    this.updatePreview();
                });
            });
        }
    }

    attachLogoEvents() {
        const uploadArea = this.modal.querySelector('#logoUploadArea');
        const fileInput = this.modal.querySelector('#logoFileInput');
        
        if (uploadArea && fileInput) {
            uploadArea.addEventListener('click', () => fileInput.click());
            
            fileInput.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                        this.state.headline.uploadedLogo = ev.target.result;
                        this.renderHeadlineContent();
                        this.updatePreview();
                    };
                    reader.readAsDataURL(file);
                }
            });
        }
        
        const sizeSlider = this.modal.querySelector('#logoSizeSlider');
        if (sizeSlider) {
            sizeSlider.addEventListener('input', (e) => {
                this.state.headline.logoSize = parseInt(e.target.value);
                this.modal.querySelector('#logoSizeValue').textContent = `${e.target.value}%`;
                this.updatePreview();
            });
        }
        
        /* Logo setup fee disabled for now
        const feeCheckbox = this.modal.querySelector('#logoSetupFee');
        if (feeCheckbox) {
            feeCheckbox.addEventListener('change', (e) => {
                this.state.headline.logoSetupFee = e.target.checked;
                this.updatePrice();
            });
        }
        */
    }

    // --- Text Events (unchanged) ---
    
    attachTextEvents() {
        this.modal.querySelectorAll('.lw-text-action-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const lineId = e.target.dataset.toggleLine;
                const action = e.target.dataset.action;
                if (lineId && this.state.text[lineId]) {
                    this.state.text[lineId].isActive = (action === 'add');
                    if (action === 'remove') this.state.text[lineId].content = ''; 
                    this.switchTab('text'); 
                    this.updatePreview();
                }
            });
        });

        this.modal.querySelectorAll('.lw-text-field[data-line-id]').forEach(lineRow => {
            const lineId = lineRow.dataset.lineId; 
            const line = this.state.text[lineId];
            if (!line) return;

            lineRow.querySelector('.lw-text-input').addEventListener('input', (e) => {
                line.content = e.target.value;
                this.updatePreview();
                if (this.state.trophyPlates[0]) this.state.trophyPlates[0][lineId] = e.target.value;
            });
            lineRow.querySelector('.lw-font-select').addEventListener('change', (e) => {
                line.font = e.target.value;
                this.updatePreview();
            });
            lineRow.querySelectorAll('.lw-size-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const delta = parseInt(btn.dataset.delta);
                    line.size = Math.max(8, Math.min(120, line.size + delta));
                    lineRow.querySelector('.lw-size-control span').textContent = `${line.size}px`;
                    this.updatePreview();
                });
            });
            lineRow.querySelectorAll('.lw-style-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const style = btn.dataset.style; 
                    line[style] = !line[style];
                    btn.classList.toggle('active', line[style]);
                    this.updatePreview();
                });
            });
        });
    }
    
    // --- Quantity Events (unchanged) ---

    attachQuantityEvents() {
        // Table input and copy checkbox handlers only (qty control is in footer)
        this.attachTableInputListeners(this.modal.querySelectorAll('.lw-table-input'));
        this.modal.querySelectorAll('.lw-copy-checkbox input').forEach(cb => {
            cb.addEventListener('change', (e) => {
                const field = e.target.dataset.copyField;
                this.state.copyPlateSettings[field] = e.target.checked;
                const sourceValue = this.state.trophyPlates[0] ? this.state.trophyPlates[0][field] : '';
                this.modal.querySelectorAll(`.lw-table-input[data-field="${field}"]`).forEach(input => {
                    const index = parseInt(input.dataset.plateIndex);
                    if (index > 0) {
                        if (this.state.copyPlateSettings[field]) {
                            input.value = sourceValue;
                            this.state.trophyPlates[index][field] = sourceValue; 
                            input.readOnly = true;
                        } else input.readOnly = false;
                    }
                });
            });
        });
    }

    attachTableInputListeners(inputs) {
        inputs.forEach(input => {
            const newInput = input.cloneNode(true);
            input.parentNode.replaceChild(newInput, input);
            newInput.addEventListener('input', (e) => {
                const index = parseInt(e.target.dataset.plateIndex);
                const field = e.target.dataset.field;
                const newValue = e.target.value;
                if (this.state.trophyPlates[index]) this.state.trophyPlates[index][field] = newValue;
                if (index === 0) this.state.text[field].content = newValue;
                if (index === 0 && this.state.copyPlateSettings[field]) {
                    for (let i = 1; i < this.state.quantity; i++) {
                        if (this.state.trophyPlates[i]) this.state.trophyPlates[i][field] = newValue;
                    }
                    this.modal.querySelectorAll(`.lw-table-input[data-field="${field}"]`).forEach(inputField => {
                        const inputIndex = parseInt(inputField.dataset.plateIndex);
                        if (inputIndex > 0) inputField.value = newValue;
                    });
                }
            });
        });
    }

    // =============================================
    // TAB SWITCHING
    // =============================================

    switchTab(tabName) {
        this.modal.querySelectorAll('.lw-cuptrophy-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === tabName);
        });
        const contentArea = this.modal.querySelector('.lw-cuptrophy-tab-content');
        switch (tabName) {
            case 'plate-options':
                contentArea.innerHTML = this.renderPlateOptionsTab();
                this.attachPlateOptionsEvents();
                break;
            case 'headline':
                contentArea.innerHTML = this.renderHeadlineTab();
                this.attachHeadlineEvents();
                this.renderHeadlineContent();
                break;
            case 'text':
                contentArea.innerHTML = this.renderTextTab();
                this.attachTextEvents();
                break;
            case 'quantity':
                contentArea.innerHTML = this.renderQuantityTab();
                this.attachQuantityEvents();
                break;
        }
    }

    // =============================================
    // PREVIEW RENDERING
    // =============================================

    updatePreview() {
        const basePlate = this.modal.querySelector('.lw-cuptrophy-baseplate');
        const plate = this.modal.querySelector('.lw-cuptrophy-plate');
        const headlineLayer = this.modal.querySelector('.lw-headline-layer');
        const textLayer = this.modal.querySelector('.lw-text-layer');
        const plateConfig = this.state.style.plateColor;
        
        // Update plate shape
        const previewContainer = this.modal.querySelector('.lw-cuptrophy-preview-container');
        if (previewContainer) {
            previewContainer.dataset.plateShape = this.state.product.plateShape;
            previewContainer.style.aspectRatio = this.getPlateAspectRatio();
        }
        
        if (this.state.product.isAcrylic) {
            plate.style.backgroundImage = 'none';
            plate.style.backgroundColor = plateConfig.bgColor;
        } else {
            plate.style.backgroundColor = 'none';
            plate.style.backgroundImage = `url('${this.config.backgroundPlates[plateConfig.bgColorKey]}')`;
        }
        
        if (this.state.style.useBasePlate && !this.state.product.isAcrylic) {
            let basePlateUrl = (plateConfig.engravingColor === '#B8A35F') ? this.config.basePlates.Gold.url : this.config.basePlates.Silver.url;
            basePlate.style.backgroundImage = `url('${basePlateUrl}')`;
            basePlate.style.setProperty('display', 'block', 'important');
        } else {
            basePlate.style.setProperty('display', 'none', 'important');
        }

        // Update headline
        this.updateHeadlineLayer(headlineLayer);

        // Update text
        this.updateTextLayer(textLayer);
    }

    updateHeadlineLayer(layer) {
        layer.innerHTML = '';
        const engravingColor = this.state.style.plateColor.engravingColor;

        const hasHeadline = (this.state.headline.type === 'Template' && this.state.headline.template) ||
                           (this.state.headline.type === 'Custom' && this.state.headline.customText) ||
                           (this.state.headline.type === 'Logo' && this.state.headline.uploadedLogo);
        
        layer.parentElement.classList.toggle('has-headline', hasHeadline);
        
        if (this.state.headline.type === 'Template' && this.state.headline.template) {
            const img = document.createElement('img');
            img.src = this.state.headline.template.url;
            img.style.filter = this.getSVGFilter(engravingColor);
            layer.appendChild(img);
        } else if (this.state.headline.type === 'Custom' && this.state.headline.customText) {
            const div = document.createElement('div');
            div.className = 'lw-custom-headline-text';
            div.style.fontFamily = this.state.headline.customFont;
            div.style.fontSize = `${this.state.headline.customSize}px`;
            div.style.color = engravingColor;
            div.textContent = this.state.headline.customText;
            layer.appendChild(div);
        } else if (this.state.headline.type === 'Logo' && this.state.headline.uploadedLogo) {
            const img = document.createElement('img');
            img.src = this.state.headline.uploadedLogo;
            img.className = 'lw-uploaded-logo';
            img.style.maxWidth = `${this.state.headline.logoSize}%`;
            img.style.maxHeight = `${this.state.headline.logoSize}%`;
            layer.appendChild(img);
        }
    }
    
    updateTextLayer(layer) {
        layer.innerHTML = '';
        const engravingColor = this.state.style.plateColor.engravingColor;
        ['line1', 'line2', 'line3', 'line4'].forEach(id => {
            const line = this.state.text[id];
            if (line.isActive && line.content) {
                const div = document.createElement('div');
                div.className = `lw-cuptrophy-text-line`;
                div.style.fontFamily = line.font;
                div.style.fontSize = `${line.size}px`;
                div.style.color = engravingColor;
                div.style.fontWeight = line.isBold ? 'bold' : 'normal';
                div.style.fontStyle = line.isItalic ? 'italic' : 'normal';
                div.textContent = line.content;
                layer.appendChild(div);
            }
        });
    }

    getSVGFilter(color) {
        if (color === '#C4C4C4') { // Silver
            return 'brightness(0) saturate(100%) invert(79%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(98%) contrast(88%)';
        } else if (color === '#B8A35F') { // Gold
            return 'brightness(0) saturate(100%) invert(72%) sepia(15%) saturate(1149%) hue-rotate(2deg) brightness(91%) contrast(87%)';
        } else if (color === '#f7f7f7') { // White/Acrylic
            return 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(14%) hue-rotate(242deg) brightness(104%) contrast(95%)';
        }
        return '';
    }

    // =============================================
    // PRICING
    // =============================================
    
    renderPriceBreakdown() {
        const perItemPrice = this.calculatePerItemPrice();
        // const logoCost = this.state.headline.logoSetupFee ? this.config.fees.logoSetup : 0; // Logo setup fee disabled for now
        const logoCost = 0;
        const total = (perItemPrice * this.state.quantity) + logoCost;

        const plateColorCost = this.state.style.plateColor.cost || 0;
        const basePlateCost = this.state.style.useBasePlate && !this.state.product.isAcrylic ? this.config.basePlates.Gold.cost : 0;
        const baseUnitPrice = this.getBaseUnitPrice();

        let breakdown = `<div class="lw-price-line"><span>Base Item (${this.state.product.variantTitle === 'Default Title' ? 'Trophy' : this.state.product.variantTitle}):</span><span>$${baseUnitPrice.toFixed(2)}</span></div>`;
        if (plateColorCost > 0) breakdown += `<div class="lw-price-line"><span>Plate Color Add-on:</span><span>$${plateColorCost.toFixed(2)}</span></div>`;
        if (basePlateCost > 0) breakdown += `<div class="lw-price-line"><span>Base Plate Add-on:</span><span>$${basePlateCost.toFixed(2)}</span></div>`;
        breakdown += `<div class="lw-price-line subtotal"><span>Price Per Item:</span><span>$${perItemPrice.toFixed(2)}</span></div>`;
        breakdown += `<div class="lw-price-line"><span>Quantity:</span><span>&times; ${this.state.quantity}</span></div>`;
        // if (logoCost > 0) breakdown += `<div class="lw-price-line"><span>Logo Setup Fee:</span><span>$${logoCost.toFixed(2)}</span></div>`; // Logo setup fee disabled for now
        breakdown += `<div class="lw-price-line total"><span>Total:</span><span>$${total.toFixed(2)}</span></div>`;
        return breakdown;
    }

    // Gets the base unit price factoring in qty break tiers from the page
    getBaseUnitPrice() {
        let price = this.state.product.basePrice || 0;

        // Read the currently checked qty-break radio for tiered pricing
        const radios = document.querySelectorAll('input[name="product-qty-breaks"]');
        let bestTier = null;
        radios.forEach(r => {
            const qty = parseInt(r.dataset.qty);
            if (qty <= this.state.quantity && (!bestTier || qty > bestTier.qty)) {
                bestTier = { qty: qty, el: r };
            }
        });

        if (bestTier) {
            const raw = bestTier.el.dataset.totalPrice;
            if (raw) price = parseFloat(raw.replace(/[^0-9.]/g, '')) / bestTier.qty;
        }

        return price;
    }
    
    calculatePerItemPrice() {
        let price = this.getBaseUnitPrice();
        
        // Plate color surcharge
        price += (this.state.style.plateColor.cost || 0);
        
        // Base plate surcharge
        if (this.state.style.useBasePlate && !this.state.product.isAcrylic) {
            price += this.config.basePlates.Gold.cost;
        }
        
        return price;
    }

    calculateTotalPrice() {
        let total = this.calculatePerItemPrice() * this.state.quantity;
        // const logoCost = this.state.headline.logoSetupFee ? this.config.fees.logoSetup : 0; // Logo setup fee disabled for now
        // if (logoCost) total += logoCost;
        return total;
    }
    
    updatePrice() {
        const perItemEl = this.modal.querySelector('.lw-cuptrophy-price-per-item');
        const totalEl = this.modal.querySelector('.lw-cuptrophy-price-value');
        
        if (perItemEl) {
            perItemEl.textContent = `$${this.calculatePerItemPrice().toFixed(2)}`;
        }
        if (totalEl) {
            totalEl.textContent = `$${this.calculateTotalPrice().toFixed(2)}`;
        }

        const breakdownEl = this.modal.querySelector('.lw-price-breakdown');
        if (breakdownEl && this.modal.querySelector('[data-tab="quantity"].active')) breakdownEl.innerHTML = this.renderPriceBreakdown();
    }

    // =============================================
    // PREVIEW IMAGE GENERATION
    // =============================================
    
    async generatePreviewImage() {
        if (typeof html2canvas === 'undefined') return null;
        const previewContainer = this.modal.querySelector('.lw-cuptrophy-preview-container');
        if (!previewContainer) return null;

        const generateWithTimeout = async () => {
            const imagesToPreload = [];
            if (!this.state.product.isAcrylic) {
                const plateConfig = this.state.style.plateColor;
                if (plateConfig && this.config.backgroundPlates[plateConfig.bgColorKey]) imagesToPreload.push(this.config.backgroundPlates[plateConfig.bgColorKey]);
            }
            if (this.state.style.useBasePlate && !this.state.product.isAcrylic) {
                 let url = (this.state.style.plateColor.engravingColor === '#B8A35F') ? this.config.basePlates.Gold.url : this.config.basePlates.Silver.url;
                 imagesToPreload.push(url);
            }

            await Promise.all(imagesToPreload.map(url => new Promise(resolve => {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = url;
                img.onload = resolve;
                img.onerror = resolve;
            })));
            
            const basePlateElement = previewContainer.querySelector('.lw-cuptrophy-baseplate');
            if (this.state.style.useBasePlate && !this.state.product.isAcrylic && basePlateElement) {
                let basePlateUrl = (this.state.style.plateColor.engravingColor === '#B8A35F') ? this.config.basePlates.Gold.url : this.config.basePlates.Silver.url;
                basePlateElement.style.cssText = `display: block !important; background-image: url('${basePlateUrl}') !important; background-size: cover !important; background-position: center !important; position: absolute !important; width: 106.25% !important; height: 107.14% !important; top: -3.57% !important; left: -3.125% !important; z-index: 1 !important;`;
                basePlateElement.offsetHeight;
                await new Promise(resolve => setTimeout(resolve, 50));
            }
            
            let captureX = 0, captureY = 0;
            let captureWidth = previewContainer.scrollWidth;
            let captureHeight = previewContainer.scrollHeight;

            if (this.state.style.useBasePlate && !this.state.product.isAcrylic) {
                const extraWidth = captureWidth * 0.0625;
                const extraHeight = captureHeight * 0.0714; 
                captureX = -extraWidth / 2;
                captureY = -extraHeight / 2;
                captureWidth += extraWidth;
                captureHeight += extraHeight;
            }

            const scale = 0.5; 

            const plateCanvas = await html2canvas(previewContainer, {
                backgroundColor: null, 
                scale: scale,
                logging: false,
                allowTaint: true,
                useCORS: true,
                x: captureX, y: captureY, width: captureWidth, height: captureHeight,
                ignoreElements: (element) => element.tagName === 'PREDICTIVE-SEARCH'
            });
            
            const variantImg = new Image();
            variantImg.crossOrigin = "anonymous";
            variantImg.src = this.state.product.featuredImage;
            await new Promise((resolve, reject) => {
                variantImg.onload = resolve;
                variantImg.onerror = resolve;
            });
            
            const finalCanvas = document.createElement('canvas');
            const ctx = finalCanvas.getContext('2d');
            const plateWidth = plateCanvas.width;
            const plateHeight = plateCanvas.height;
            const variantScale = plateWidth / variantImg.width;
            const variantHeight = variantImg.height * variantScale;

            finalCanvas.width = plateWidth;
            finalCanvas.height = plateHeight + variantHeight;

            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
            ctx.drawImage(plateCanvas, 0, 0);
            ctx.drawImage(variantImg, 0, plateHeight, plateWidth, variantHeight);
            
            return finalCanvas.toDataURL('image/jpeg', 0.80);
        };

        try {
            const result = await Promise.race([
                generateWithTimeout(),
                new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 2000))
            ]);
            return result;
        } catch (e) {
            return null; 
        }
    }

    // =============================================
    // ADD TO CART
    // =============================================

    async addToCart() {
        if (!confirm(`You are adding ${this.state.quantity} custom item(s) to your cart. Proceed?`)) return;

        const btn = this.modal.querySelector('#addToCartBtn');
        btn.disabled = true;
        btn.textContent = 'Processing...';

        const processingOverlay = this.modal.querySelector('#lw-processing-overlay');
        const loadingOverlay = this.modal.querySelector('#lw-loading');
        
        try {
            try {
                await ensureHtml2CanvasLoaded();
            } catch(e) { console.log('Canvas load warning'); }

            if (processingOverlay) processingOverlay.style.display = 'flex';

            let previewImage = null;
            try {
                previewImage = await this.generatePreviewImage();
            } catch (e) {
                console.warn('Preview skipped due to error');
            }

            if (processingOverlay) processingOverlay.style.display = 'none';
            if (loadingOverlay) loadingOverlay.style.display = 'flex';
            btn.textContent = 'Adding to Cart...';
            
            const properties = {
                '_Program': 'CupTrophyCustomizer v3.0',
                'Plate Color': this.state.style.plateColor.name,
                'Plate Shape': this.config.plateShapes[this.state.product.plateShape].label,
                'Base Plate': this.state.style.useBasePlate && !this.state.product.isAcrylic ? `Yes (+$${this.config.basePlates.Gold.cost.toFixed(2)})` : 'No'
            };

            // Add headline info
            let headlineInfo = 'None';
            if (this.state.headline.type === 'Template' && this.state.headline.template) {
                headlineInfo = `Template: ${this.state.headline.template.name}`;
            } else if (this.state.headline.type === 'Custom' && this.state.headline.customText) {
                headlineInfo = `Custom: ${this.state.headline.customText}`;
            } else if (this.state.headline.type === 'Logo') {
                headlineInfo = 'Uploaded Logo';
                /* Logo setup fee disabled for now
                if (this.state.headline.logoSetupFee) {
                    properties['Logo Setup Fee'] = `Yes (+$${this.config.fees.logoSetup.toFixed(2)})`;
                }
                */
            }
            properties['Headline'] = headlineInfo;
            
            ['line1', 'line2', 'line3', 'line4'].forEach(l => {
                const lineData = this.state.text[l];
                if (lineData.isActive) {
                    const fontName = lineData.font.split(',')[0].replace(/['"]/g, '');
                    let styleStr = `${fontName}, ${lineData.size}px`;
                    if (lineData.isBold) styleStr += ', Bold';
                    if (lineData.isItalic) styleStr += ', Italic';
                    properties[`${l.replace('line', 'Line ')} Specs`] = styleStr;
                }
            });
            
            if (previewImage) properties['_preview'] = previewImage;
            
            this.syncPlatesArray();

            if (this.state.quantity === 1) {
                ['line1', 'line2', 'line3', 'line4'].forEach(l => {
                    if (this.state.text[l].isActive) properties[l.replace('line', 'Line ')] = this.state.trophyPlates[0][l];
                });
            } else {
                properties['Plates'] = `${this.state.quantity} Total`;
                this.state.trophyPlates.forEach((plate, index) => {
                    ['line1', 'line2', 'line3', 'line4'].forEach(l => {
                        if (this.state.text[l].isActive) properties[`Item ${index + 1} - ${l.replace('line', 'Line ')}`] = plate[l] || 'n/a';
                    });
                });
            }
            
            const plateColorCost = this.state.style.plateColor.cost || 0;
            const basePlateCost = this.state.style.useBasePlate && !this.state.product.isAcrylic ? this.config.basePlates.Gold.cost : 0;
            // const logoCost = this.state.headline.logoSetupFee ? this.config.fees.logoSetup : 0; // Logo setup fee disabled for now
            const logoCost = 0;
            const perItemSurchargeDollars = plateColorCost + basePlateCost;
            const totalSurchargeInCents = Math.round(((perItemSurchargeDollars * this.state.quantity) + logoCost) * 100);

            if (totalSurchargeInCents > 0) {
                properties['_addon_price'] = totalSurchargeInCents.toString();
                const breakdown = [];
                if (plateColorCost) breakdown.push(`Color: $${plateColorCost.toFixed(2)}`);
                if (basePlateCost) breakdown.push(`Base Plate: $${basePlateCost.toFixed(2)}`);
                // if (logoCost) breakdown.push(`Logo Setup: $${logoCost.toFixed(2)}`); // Logo setup fee disabled for now
                properties['_surcharge_breakdown'] = breakdown.join(', ');
            }

            const finalVariantId = this.state.product.variantId;
            if (!finalVariantId) throw new Error("Variant ID missing");

            const formData = new FormData();
            formData.append('id', finalVariantId);
            formData.append('quantity', this.state.quantity);
            Object.entries(properties).forEach(([key, value]) => formData.append(`properties[${key}]`, value));
            
            const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
            
            if (response.ok) {
                this.close();
                sessionStorage.setItem('openCartDrawer', 'true');
                window.location.href = '/cart';
            } else {
                throw new Error('Cart add failed');
            }
            
        } catch (error) {
            console.error('Cart error:', error);
            const processingOv = this.modal?.querySelector('#lw-processing-overlay');
            const loadingOv = this.modal?.querySelector('#lw-loading');
            if (processingOv) processingOv.style.display = 'none';
            if (loadingOv) loadingOv.style.display = 'none';
            alert('Failed to add to cart. Please try again.');
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
        }
    }
} 

let html2canvasLoaded = false;
let html2canvasPromise = null;
function ensureHtml2CanvasLoaded() {
    if (html2canvasLoaded) return Promise.resolve();
    if (html2canvasPromise) return html2canvasPromise;
    html2canvasPromise = new Promise((resolve, reject) => {
        if (typeof html2canvas !== 'undefined') { html2canvasLoaded = true; resolve(); return; }
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
        script.onload = () => { html2canvasLoaded = true; resolve(); };
        script.onerror = () => reject(new Error('Failed to load html2canvas'));
        document.head.appendChild(script);
    });
    return html2canvasPromise;
}

window.cupTrophyInstance = null; 
function initializeCupTrophyCustomizer() {
    console.log('[TROPHY] Cup Trophy Script: Initializing...'); 
    if (window.cupTrophyInstance) {
         document.removeEventListener('click', window.cupTrophyInstance.boundTriggerHandler);
    }
    const oldModal = document.querySelector('.lw-cuptrophy-modal');
    if (oldModal) { oldModal.remove(); document.body.classList.remove('lw-modal-open'); }
    
    window.cupTrophyInstance = new CupTrophyCustomizer();
    console.log('[OK] Cup Trophy Customizer v3.0 is ready!');
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCupTrophyCustomizer);
else initializeCupTrophyCustomizer();

window.addEventListener('pageshow', (event) => {
    if (event.persisted) initializeCupTrophyCustomizer();
});